import { getI18nData } from '../../business/i18n';
const homeData = {
  COUPON_LIST_TITLE: getI18nData('COUPON_LIST_TITLE'),
  STAMP_LIST_TITLE: getI18nData('STAMP_LIST_TITLE'),
  EXCHANGE_LIST_TITLE: getI18nData('EXCHANGE_LIST_TITLE'),
  NO_RECORD: getI18nData('NO_RECORD'),
  LOOK_HISTORY_LIST_TIPS: getI18nData('LOOK_HISTORY_LIST_TIPS'),
  NOT_ACT_TIPS: getI18nData('NOT_ACT_TIPS'),
  DICOUNT_HEADER_TITLE: getI18nData('DICOUNT_HEADER_TITLE'),
  New: getI18nData('New'),
  ACT_TIME_INFO: getI18nData('ACT_TIME_INFO'),
  ACT_DETAIL_TIPS: getI18nData('ACT_DETAIL_TIPS'),
  NO_DISCOUNT_RECORD: getI18nData('NO_DISCOUNT_RECORD'),
  GO_UNUSABLE: getI18nData('GO_UNUSABLE'),
  NO_STAMP: getI18nData('NO_STAMP'),
  NO_UNUSE_STAMP: getI18nData('NO_UNUSE_STAMP'),
  EXPIRE_ICON: getI18nData('EXPIRE_ICON'),
  NEED_ONE_TIPS: getI18nData('NEED_ONE_TIPS'),
  HISTORY_LIMIT_TIPS: getI18nData('HISTORY_LIMIT_TIPS'),
  EXPIRE_STAMP: getI18nData('EXPIRE_STAMP'),
  HAVE_PRIZE: getI18nData('HAVE_PRIZE'),
  NEED_MORE: getI18nData('NEED_MORE'),
  NEED_MORE_TIPS: getI18nData('NEED_MORE_TIPS'),
  INDEX_TITLE: getI18nData('INDEX_TITLE'),
  HISTORY_TITLE: getI18nData('HISTORY_TITLE'),
  ACT_DATE_START_TIPS: getI18nData('ACT_DATE_START_TIPS'),
  ACT_DATE_END_TIPS: getI18nData('ACT_DATE_END_TIPS'),
  HEADER_COUPON_EXPIRE_DESC: getI18nData('HEADER_COUPON_EXPIRE_DESC'),
  HEADER_EXPIRE_DESC: getI18nData('HEADER_EXPIRE_DESC'),
  HEADER_STAMP_EXPIRE_DESC: getI18nData('HEADER_STAMP_EXPIRE_DESC'),
  HEADER_EXCHANGE_EXPIRE_DESC: getI18nData('HEADER_EXCHANGE_EXPIRE_DESC'),
  ACT_LIST_TITLE: getI18nData('ACT_LIST_TITLE'),
  ACT_CHECK_DETAIL: getI18nData('ACT_CHECK_DETAIL'),
  PROM_BANNER_GO_DETAIL: getI18nData('PROM_BANNER_GO_DETAIL'),
  PROM_BANNER_TOUCH_UP: getI18nData('PROM_BANNER_TOUCH_UP'),
  STORE_LIST_TITLE: getI18nData('STORE_LIST_TITLE'),
  HEADER_COUPON_TITLE: getI18nData('HEADER_COUPON_TITLE'),

  stamp_class: 'navigator-item',
  coupon_class: 'navigator-item',
  display_coupon_class: 'navigator-item',
  expire_header_data: {
    stamp: 0,
    coupon: 0,
  },
  listData: [],
};
export default homeData;
